module.exports = __webpack_public_path__ + "static/media/p-1.7a082c0d.png";